export default {
    title: "History Imports",
    startDateLabel: "Start date",
    endDateLabel: "End date",
    startImportButton: "Start import",
    applyLabel: "Apply",
    cancelLabel: "Cancel",
    startSuccessNotification: "History import started successfully",
    confirmTitle: "Are you sure?",
    confirmPrefix: "You are about to",
    confirmHighlight: "cancel this history import",
    confirmIrreversible: "This action is NOT reversible.",
    columnId: "ID",
    columnStartDate: "Start Date",
    columnEndDate: "End Date",
    columnLastImportedDate: "Last Imported Date",
    columnStatus: "Status",
    columnImportedDays: "Imported days",
    columnRemainingDays: "Remaining days",
    columnProgress: "Progress",
    columnActions: "Actions",
    noImportPerformed: "No import performed",
    cancelButton: "Cancel",
    cancelSuccessNotification: "History import cancelled",
    cancelErrorNotification: "Error cancelling import",
    statusComplete: "Complete",
    statusCancelled: "Cancelled",
    statusInProgress: "Processing",
    statusPending: "Pending",
    statusFailed: "Failed",
    daySun: "Sun",
    dayMon: "Mon",
    dayTue: "Tue",
    dayWed: "Wed",
    dayThu: "Thu",
    dayFri: "Fri",
    daySat: "Sat",
    monthJan: "Jan",
    monthFeb: "Feb",
    monthMar: "Mar",
    monthApr: "Apr",
    monthMay: "May",
    monthJun: "Jun",
    monthJul: "Jul",
    monthAug: "Aug",
    monthSep: "Sep",
    monthOct: "Oct",
    monthNov: "Nov",
    monthDec: "Dec",
};
